import { Logger, LoggerService } from "@Shared/logger";
import { ITemplate } from "./template.interface";
export abstract class Template  {
    private BaseLogger: Logger = LoggerService.createLogger("Template");

    protected isInjectd = false;
    protected isVisible = false;
    protected html: string;
    protected logoUrl: string;

    protected container: HTMLElement | null = null;
    get Container(): HTMLElement | null {
        return this.container;
    }

    constructor() {
        // Constructor logic here
        this.BaseLogger.trace("****  CTOR ****");
    }
    
    protected abstract renderTemplate(): void;

    public abstract showTemplate(): void;
    public abstract closeTemplate(): void;

    protected renderBaseTemplate(): void{
        this.BaseLogger.trace("renderTemplate.BASE");
        const templateDiv = document.createElement('div');
        templateDiv.innerHTML = this.html;
        this.container = templateDiv.firstElementChild as HTMLElement;

        if (!this.container) {
            this.BaseLogger.error("Template could not be parsed.");            
            return;
        }
    }

    setup(): void {
        this.BaseLogger.trace("setup called");
        if (!this.isInjectd) {
            this.BaseLogger.info("Injecting template");
            this.renderBaseTemplate();
            this.isInjectd = true;
        }
    }

    
    
}